module.exports = __webpack_public_path__ + "img/Icon ionic-md-move.12987b1e.svg";